import ls from '../../utils/localStorage.js';
import { getCategories,getArticle,getArticleDetail } from '../../api/api';

const state = {
  categories: '',
  article_list: '',
  article_detail: ''
}

const mutations = {
    UPDATE_CATEGORIES(state,payload) {
        state.categories = JSON.parse(payload);
    },
    UPDATE_ARTICLE_LIST(state,payload) {
        state.article_list = JSON.parse(payload);
    },
    UPDATE_ARTICLE_DETAIL(state,payload) {
        state.article_detail = JSON.parse(payload);
    }
}

const getters = {

}

const actions = {

    // 获取类别
    requestCategories(store,item) {
        getCategories().then( data => {
            store.commit('UPDATE_CATEGORIES',JSON.stringify(data));
        }).catch(error => {
           
        })
    },

    // 获取文章列表
    requestArticle(store,item) {
        getArticle(item.category,item.city).then( data => {
            item.thit.loading = true;
            store.commit('UPDATE_ARTICLE_LIST',JSON.stringify(data));
        }).catch(error => {
            
        })
    },

    // 获取文章详情
    requestArticleDetail(store,item) {
        getArticleDetail(item.id).then( data => {
            store.commit('UPDATE_ARTICLE_DETAIL',JSON.stringify(data));
        }).catch(error => {
            
        })
    }

}

export default {
    state,
    mutations,
    getters,
    actions
}
